import httpService from '@Utils/httpService';

const baseUrl = 'api/images360';

export default {
    get(params, requestOptions = {}) {
        return httpService.get({
            ...requestOptions,
            url: baseUrl,
            params,
        });
    },
    getById(id, facilityId = null) {
        return httpService.get({
            url: `${baseUrl}/${id}`,
            ...(facilityId ? { params: { facilityId } } : {}),
        });
    },
};
